import eventBus from '@/helpers/event-bus';
import { startNotification } from '@/notifications';

/*
 * يشغّل إشعارات FCM:
 * 1. يطلب صلاحية الإشعارات ويجلب توكن الجهاز (يُخزَّن في localStorage داخل startNotification).
 * 2. يسجّل التوكن في الباك-إند عبر notifications/registerDeviceToken.
 * 3. يعرض إشعارات foreground ويبثّ 'FCM-message' على eventBus لبقية التطبيق.
 */
function startNotificationsFunctionality ({ store, router }) {
	return startNotification(
		{ router },
		(payload) => { eventBus.$emit('FCM-message', payload); }
	).then((token) => {
		if (token) { store.dispatch('notifications/registerDeviceToken', { token }); }
		return token;
	}).catch((e) => {
		console.error('Notifications error:', e);
	});
}

export default function initNotifications ({ store, router }) {
	if (!('serviceWorker' in navigator) || !('Notification' in window)) return;

	// التنقّل عند الضغط على إشعار وصل في الخلفية (يرسله firebase-messaging-sw.js)
	navigator.serviceWorker.addEventListener('message', (event) => {
		if (event.data && event.data.type === 'WORKER_NAVIGATE') {
			router.push(event.data.redirectUrl).catch(() => {});
		}
	});

	// ابدأ فوراً إذا كان المستخدم مسجّلاً بالفعل عند فتح التطبيق
	if (store.state.auth.authenticated) {
		startNotificationsFunctionality({ store, router });
	}

	// ابدأ عند تسجيل الدخول لاحقاً (دون إعادة تحميل الصفحة)
	store.watch(
		(state) => state.auth.authenticated,
		(isAuthenticated) => {
			if (isAuthenticated) { startNotificationsFunctionality({ store, router }); }
		}
	);
}
